import React, { useState, useEffect, createContext, useContext, useCallback } from 'react';
import { getUserName, signIn as sendSignInRequest } from '../api/auth';
import { localStorageService } from '../services/localstorage-service';


function AuthProvider(props) {
  const [user, setUser] = useState();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async function () {
      const result = await getUserName();
      if (result.isOk) {
        setUser(result.data);
      }

      setLoading(false);
    })();
  }, []);

  const signIn = useCallback(async (email, password, isChecked) => {
    const result = await sendSignInRequest(email, password, isChecked);
    if (result.isOk) {
      setUser(result.data);
      localStorageService.setUserRoleType(result.data.employee.roleRights);
    }

    return result;
  }, []);

  const signOut = useCallback(() => {
    setUser(null);
    localStorageService.clearStorage();
  }, []);


  return (
    <AuthContext.Provider value={{ user, signIn, signOut, loading }} {...props} />
  );
}

const AuthContext = createContext({ loading: false });
const useAuth = () => useContext(AuthContext);

export { AuthProvider, useAuth }
